import { Place, setPlaces, getPlaces, filterPlaces } from './data';
import { initMap, renderMarkers, renderCorridors, toggleCorridors, showCorridors, areCorridorsVisible, deselectMarker, panToPlace, fitToPlaces } from './map';
import { initFilters, getFilterState } from './filters';
import { initSidebar, openPlace, openCorridor } from './sidebar';
import { initOnboarding } from './onboarding';
import { t, getLang, setLang, toggleLang } from './i18n';
// @ts-ignore — JSON import handled by esbuild
import seedData from '../data/places.json';

function init(): void {
  setPlaces(seedData as Place[]);
  initMap();
  initSidebar(() => deselectMarker());
  initFilters((filtered: Place[]) => renderMarkers(filtered, handlePlaceClick));

  const allPlaces = getPlaces();
  renderMarkers(allPlaces, handlePlaceClick);
  renderCorridors(openCorridor);

  document.getElementById('btn-corridors')?.addEventListener('click', () => {
    const visible = toggleCorridors();
    const btn = document.getElementById('btn-corridors')!;
    btn.classList.toggle('active', visible);
  });

  window.addEventListener('show-corridors', () => {
    showCorridors();
    const btn = document.getElementById('btn-corridors');
    if (btn) btn.classList.add('active');
  });

  document.getElementById('btn-lang')?.addEventListener('click', () => {
    toggleLang();
    // Re-render markers with new language tooltips
    const state = getFilterState();
    const filtered = filterPlaces(state);
    renderMarkers(filtered, handlePlaceClick);
    if (areCorridorsVisible()) renderCorridors(openCorridor);
    updateLangButton();
  });

  setLang(getLang());
  updateLangButton();

  document.getElementById('btn-print')?.addEventListener('click', () => {
    window.print();
  });

  buildPrintChecklist(allPlaces);
  initOnboarding();
  fitToPlaces(allPlaces);
}

function handlePlaceClick(place: Place): void {
  openPlace(place);
  panToPlace(place);
}

function updateLangButton(): void {
  const btn = document.getElementById('btn-lang');
  if (btn) {
    btn.textContent = getLang() === 'zh' ? 'EN' : '中文';
  }
}

function buildPrintChecklist(places: Place[]): void {
  const el = document.getElementById('print-checklist');
  if (!el) return;

  const sections = [
    { title: 'Get Groceries / 买菜购物', subs: ['Chinese grocery store'] },
    { title: 'Get a SIM Card / 办手机卡', subs: ['Phone/SIM card shop'] },
    { title: 'Open a Bank Account / 开银行账户', subs: ['Bank with Chinese-speaking staff'] },
    { title: 'Find Comfort Food / 找家乡味', subs: ['Regional Chinese restaurant', 'Late-night food', 'Boba tea shop'] },
    { title: 'Essential Services / 必备服务', subs: ['Shipping services to China', 'DMV office', 'Immigration attorney'] },
  ];

  let html = `<h1>First 72 Hours in LA / 洛杉矶头72小时清单</h1>`;
  html += `<p class="print-subtitle">落脚 LuoJiao — luojiao.pages.dev</p>`;

  sections.forEach(section => {
    const matched = places.filter(p => section.subs.includes(p.subcategory));
    if (matched.length === 0) return;
    html += `<div class="checklist-section"><h2>${section.title}</h2>`;
    matched.forEach(p => {
      html += `<div class="checklist-item">
        <div class="check-box"></div>
        <div><span class="item-name">${p.name_zh} / ${p.name_en}</span><br><span class="item-addr">${p.address}</span></div>
      </div>`;
    });
    html += `</div>`;
  });

  html += `<div class="print-footer">Generated by 落脚 LuoJiao — No accounts. No tracking. 我们不收集任何数据。</div>`;
  el.innerHTML = html;
}

// Start
document.addEventListener('DOMContentLoaded', init);
